import type {
  Tournament,
  PublicPlayer,
  StandingsResponse,
  CrossTableResponse,
  PublicPairingsResponse,
  StartingListResponse,
  PlayerParticipationResponse,
} from '@swiss-magic/shared-types';
import { publicGet } from './core';

export function getPublicTournament(slug: string): Promise<Tournament> {
  return publicGet(`/t/${slug}`);
}

export function getPublicPlayers(slug: string): Promise<{
  visibility: 'list' | 'count' | 'hidden';
  players?: PublicPlayer[];
  count?: number;
}> {
  return publicGet(`/t/${slug}/players`);
}

export function getPublicStandings(slug: string): Promise<StandingsResponse> {
  return publicGet(`/t/${slug}/standings`);
}

export function getPublicCrossTable(slug: string): Promise<CrossTableResponse> {
  return publicGet(`/t/${slug}/crosstable`);
}

export function getPublicStartingList(slug: string): Promise<StartingListResponse> {
  return publicGet(`/t/${slug}/starting-list`);
}

export function getPlayerParticipation(
  slug: string,
  startingRank: string | number,
): Promise<PlayerParticipationResponse> {
  return publicGet(`/t/${slug}/player/${startingRank}`);
}

export function getPublicPairings(
  slug: string,
  roundNumber: number,
): Promise<PublicPairingsResponse> {
  return publicGet(`/t/${slug}/pairings/${roundNumber}`);
}
